module.exports = __webpack_public_path__ + "static/media/oscars_logo.59711e01.png";